import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective, AbstractControl } from '@angular/forms';
import { ToasterService } from '../../../shared/services/toaster.service';
import { CmnFunctionService } from "../../../shared/services/cmn-function.service";
import { ApiHandlerService } from '../../../shared/services/api-handler.service';
import { Router } from '@angular/router';
import { CustomPhonePipe } from '../../pipes/custom-data-filters.pipe';


@Component({
  selector: 'app-add-sos-contact',
  templateUrl: './add-sos-contact.component.html',
  styleUrls: ['./add-sos-contact.component.scss']
})


export class AddSosContactComponent implements OnInit {

  public isImageUpload: boolean = false;
  public submitted: boolean = false;
  public contactForm: FormGroup;
  public isLoadingData: boolean = false;
  public contactValue: any;
  public isEditPage: boolean = false;
  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;

  constructor(
    public cmnFunction: CmnFunctionService,
    public apiHandler: ApiHandlerService,
    public formBuilder: FormBuilder,
    public toaster: ToasterService,
    public router: Router,
    public customPhone: CustomPhonePipe,
    public cd: ChangeDetectorRef) {
    this.contactValue = this.router.getCurrentNavigation().extras.state.data;
  }
  emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      // name         : ['', Validators.required],
      name: ['', [Validators.required, this.whitespaceValidator]], // Updated
      email: ['', [
        Validators.required,
        Validators.pattern(this.emailPattern) // Use the pattern validator
      ]],
      // email: ['', [Validators.required, Validators.email]],
      mobileNumber: ['', Validators.required]
    });
    this.listenUodatedValue();
  }

  whitespaceValidator(control: AbstractControl): { [key: string]: any } | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  listenUodatedValue() {
    var self = this;
    if (self.contactValue.isEditPage) {
      //set form value initially..
      self.contactForm.setValue({
        name: self.contactValue.name,
        email: self.contactValue.email,
        mobileNumber: this.customPhone.transform(self.contactValue.phoneNo, 'US')
      });
    }
    // self.cmnFunction.updatedPageData.subscribe(data=>{
    //   if(data){
    //      self.contactValue = data;

    //     if(self.contactValue.isEditPage){
    //       //set form value initially..
    //       self.contactForm.setValue({
    //         name          : self.contactValue.name,
    //         email         : self.contactValue.email,
    //         mobileNumber  : self.contactValue.phoneNo
    //       });
    //     }
    //   }
    // })
  }

  addContact() {
    var url;
    this.submitted = true;
    if (this.contactForm.invalid) return;
    this.isLoadingData = true;

    //manage path via url....
    if (this.contactValue.isEditPage) {
      url = '/contact-edit/' + this.contactValue._id;
    } else {
      url = '/contact-save';
    }

    //API data ..
    const postData = {
      name: this.contactForm.value.name,
      email: this.contactForm.value.email,
      phoneNo: this.customPhone.transform(this.contactForm.value.mobileNumber, '')
    }

    //if page is edit-sos
    if (this.contactValue.isEditPage) {
      //updateUserDetails for update user info in the DB...
      this.apiHandler.apiUpdate(this.apiHandler.baseUrl + url, postData).subscribe({
        next: result => {
          if (result['status']) {
            this.submitted = false;
            this.isLoadingData = false;
            this.toaster.Success(result['message']);
          } else {
            this.toaster.Error(result['message']);
            this.isLoadingData = false;
          }
        }, error: err => {
          this.isLoadingData = false;
          let msg = (err.error && err.error.message) ? err.error.message : 'Invalid Credentials';
          this.toaster.Error(msg);
        }
      });
    } else {
      //updateUserDetails for update user info in the DB...
      this.apiHandler.apiPost(this.apiHandler.baseUrl + url, postData).subscribe({
        next: result => {
          if (result['status']) {
            this.submitted = false;
            this.isLoadingData = false;

            //reset form...
            this.formGroupDirective.resetForm();
            this.toaster.Success(result['message']);
          } else {
            this.toaster.Error(result['message']);
          }
        }, error: err => {
          let msg = (err.error && err.error.message) ? err.error.message : 'Invalid Credentials';
          this.toaster.Error(msg);
        }
      });
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.contactForm.controls; }

  navigateBackPage() {
    this.router.navigate(['/customer/settings']);
  }
}
